const social = [
  {
    name: 'youtube',
    type: 'social',
    size: '25px'
  },
  {
    name: 'facebook',
    type: 'social',
    size: '25px'
  },
  {
    name: 'linkedin',
    type: 'social',
    size: '25px'
  },
  {
    name: 'twitter',
    type: 'social',
    size: '25px'
  }
];

export default social;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/constants/social.js